export const LS_DASHBOARD_FILTERS = 'dashboardFilters';
export const BUILD_STATUS_LIST = [
  'Success',
  'Complete',
  'Failed',
  'Error',
  'Running',
];
export const JOB_STATUS_LIST = [
  'Passed',
  'Complete',
  'Failed',
  'Error',
  'In progress',
  'Queued',
];

export const PERFORMANCE_DEFAULT = 'highest';
export const NO_RESULTS = 'No results for the selected filters.';

export const FILTER_AUTOMATED_BUILDS = 'automated_builds';
export const FILTER_AUTOMATED_TESTS = 'automated_tests';
export const FILTER_HEADLESS_BUILDS = 'headless_builds';
export const FILTER_HEADLESS_TESTS = 'headless_tests';

export const FILTER_TYPE_STATUS = 'status';
export const FILTER_TYPE_OWNERSHIP = 'ownership';
export const FILTER_TYPE_PERFORMANCE = 'performance';
